// routes
import { PATH_REWARD, PATH_DASHBOARD, PATH_SCOUT, PATH_RECRUIT } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import Label from '../../../components/Label';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  building: getIcon('icon-building-mono'),
  reward: getIcon('icon-coin-mono'),
  crown: getIcon('icon-crown-mono'),
  job: getIcon('ic-job'),
};

const newLabel = <Label variant="filled" color="info">NEW</Label>;

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'app',
    items: [
      { title: '사이드잡 매칭', path: PATH_DASHBOARD.crew, icon: ICONS.building, matchLabel: true, siblings: [PATH_DASHBOARD.suggestion, PATH_DASHBOARD.matchingStart], crew: false },
      // TODO: 정규직 공고 오픈 후 주석해제
      // { title: '정규직 공고', path: PATH_RECRUIT.root, icon: ICONS.job, newLabel: false, siblings: [], crew: true },
      { title: '직접 스카우트하기', path: PATH_SCOUT.root, icon: ICONS.crown, newLabel: false, siblings: [], crew: true },
      { title: '지인 추천 10만원 리워드', path: PATH_REWARD.root, icon: ICONS.reward, siblings: [], crew: true },
    ],
  },
  // APP
  // ----------------------------------------------------------------------
  // import Label from '../../../components/Label';
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_WORKS.root,
  //       icon: ICONS.user,
  //       info: (
  //         <Label variant="outlined" color="error">
  //           +32
  //         </Label>
  //       ),
  //     },
  //     { title: 'chat', path: PATH_WORKS.root, icon: ICONS.user },
  //     { title: 'calendar', path: PATH_WORKS.root, icon: ICONS.invoice },
  //     { title: 'kanban', path: PATH_WORKS.root, icon: ICONS.kanban },
  //   ],
  // },
];

export default navConfig;
